const DEFAULT_COMPLIANCE_REDUX_STATE = {
  complianceData: [],
  cyberSecurity: null,
  files: [],
  initialCompliance: null,
  rating: 0,
};

export default DEFAULT_COMPLIANCE_REDUX_STATE;
